import isPropValid from '@emotion/is-prop-valid';

/**
 * Restores styled-components v5's default prop filtering, which v6 removed.
 * Non-standard props are forwarded to custom components but filtered out of
 * native DOM elements, preventing "React does not recognize the prop" warnings.
 * Pass to <StyleSheetManager shouldForwardProp={shouldForwardProp}>.
 */
export const shouldForwardProp = (prop: string, target: unknown): boolean =>
  typeof target === 'string' ? isPropValid(prop) : true;
